import { render, staticRenderFns } from "./PrivacyContent.vue?vue&type=template&id=20a4c1a7&scoped=true"
import script from "./PrivacyContent.vue?vue&type=script&lang=js"
export * from "./PrivacyContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a4c1a7",
  null
  
)

export default component.exports